import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import JobProfile from "./JobProfile/JobProfile";
import classes from "./CreateInterview.module.css";
import { Col, Row, Form, Button, Modal, Tooltip } from "react-bootstrap";
import ModeOfInterview from "./ModeOfInterview/ModeOfInterview";
import Modeofinterview from "../extInterviewSchedule/Modeofinterview";
import SelectInterviewer from "./SelectInterviewer/SelectInterviewer";
import SelectDateAndTime from "./SelectDateAndTime/SelectDateAndTime";
import PaymentPreview from "./PaymentPreview/PaymentPreview";
import StepBar from "./StepBar/StepBar";
import labels from "../../Labels/Label";

class CreateNewInterview extends Component {
  state = {
    checked: false,
    activePage: "jobProfile",
    modeOfInterview: false,
    error: {},
    selectedJobProfileId: "",
    ShowModalOpen: false,
    interviewerProfileValue: {
      id: null,
      name: null,
      profile: null,
      experienceInYears: null,
      experienceInMonths: null,
    },
    selectedJobProfile: {
      id: null,
      jobtitle: null,
      clientName: null,
      minExp: null,
      maxExp: null,
    },
    checkedJob: false,
    interviewerPagePageinate: 1,
    text: "View Slot",
    availability: "",
    candidatePageValue: { id: null, name: null, experienceInYears: null },
    interviewerChecked: false,
    availableSlot: "",
    userType: localStorage.getItem("userType"),
  };

  handleJobProfilePage = (page, data) => {
    console.log("running", page, data);
    if (page === "create") {
      this.setState({
        //modeOfInterview: true,
      });
    }

    if (page === "mode" && !!data.id) {
      //console.log('hey')
      this.setState({
        modeOfInterview: true,
        selectedJobProfileId: data,
      });
    }

    if (page === "selectInterviewPage" && !!data) {
      this.setState({
        modeOfInterview: false,
        activePage: "selectInterviewPage",
        selectedMode: data,
      });
    }

    if (page === "paymentPreview") {
      this.setState({
        activePage: "paymentPreview",
        invoiceData:
          data.position === undefined ? this.state.invoiceData : data,
      });
    }
  };

  showModeModal = () => {
    this.setState({
      modeOfInterview: false,
    });
  };

  onRadioSelectInterviewer = (event) => {
    if (event == "candidate") {
      this.setState({
        interviewerChecked: false,
        interviewerProfileValue: {
          id: null,
          name: null,
          profile: null,
          experienceInYears: null,
          experienceInMonths: null,
        },
        text: "View Slot",
      });
    } else {
      this.setState({
        interviewerChecked: true,
        interviewerProfileValue: JSON.parse(event.target.value),
        text: "View Slot",
      });
    }
  };

  onRadioUnselectInterviewer = () => {
    this.setState({
      interviewerProfileValue: {
        id: null,
        name: null,
        profile: null,
        experienceInYears: null,
        experienceInMonths: null,
      },
      text: "View Slot",
    });
  };

  gotoSelectCandidate = () => {
    this.setState({
      activePage: "jobProfile",
    });
    if (this.state.checked === true) {
      this.setState({
        jobPofilePage: false,
        candidateProfilePage: true,
        interviewerListPage: false,
      });
    } else {
      this.setState({ joberror: "Please select a job profile" });
    }
  };

  componentDidMount = () => {
    this.setState((Prev) => ({ ...Prev, ShowModalOpen: true }));
  };
  ShowModalClose = () => {
    this.setState((Prev) => ({ ...Prev, ShowModalOpen: false }));
  };
  onRadioSelectJob = (event) => {
    // console.log(JSON.parse(event.target.value))
    this.setState({
      checkedJob: true,
      selectedJobProfile: JSON.parse(event.target.value),
    });
  };

  onRadioSelect = (data) => {
    this.setState({
      availableSlot: data,
    });
  };
  interviewerPageNumber = (pageNumber) => {
    this.setState({
      interviewerChecked: false,
      interviewerPagePageinate: pageNumber,
      interviewerProfileValue: {
        id: null,
        name: null,
        profile: null,
        experienceInYears: null,
        experienceInMonths: null,
      },
    });
  };
  gotoSelectInterviewer = () => {
    this.setState({
      activePage: "selectInterviewPage",
    });
    console.log();
    if (this.state.candidateChecked) {
      this.setState({
        jobPofilePage: false,
        candidateProfilePage: false,
        interviewerListPage: true,
        interviewTimingPage: false,
      });
    }
  };

  gotoScheduleInterview = () => {
    if (this.state.interviewerChecked) {
      this.setState({
        jobPofilePage: false,
        candidateProfilePage: false,
        interviewerListPage: false,
        interviewTimingPage: true,
      });
    }
  };

  changeText = (val, interviewerValue, index) => {
    // console.log(val.target.value,interviewerValue,index);
    this.setState({
      text: val.target.value,
      interviewerProfileValue: JSON.parse(interviewerValue),
      interviewerChecked: true,
      index: index,
    });
  };

  setAvailability = (availability) => {
    this.setState({
      availability: availability,
    });
  };

  render() {
    //console.log('kkk', this.state.text)
    return (
      <div>
        {
          <Row>
            <Col md={12} style={{ display: "flex" }}>
              {this.state.userType == 0 ? (
                <div className={classes.heading}>
                  <h3>{labels.counsellorHeading}</h3>
                </div>
              ) : (
                <div className={classes.heading}>
                  <h3>{labels.interviewHeading}</h3>
                </div>
              )}
              {<StepBar active={this.state.activePage} />}
            </Col>
          </Row>
        }
        {this.state.userType !== "0" &&
          this.state.activePage === "jobProfile" && (
            <JobProfile
              handleJobProfilePage={this.handleJobProfilePage}
              onRadioSelectInterviewer={this.onRadioSelectInterviewer}
              checkedJob={this.state.checkedJob}
              selectedJobProfile={this.state.selectedJobProfile}
              onRadioSelectJob={this.onRadioSelectJob}
            />
          )}

        {/* {this.state.activePage === "selectInterviewPage" && ( */}
        <SelectInterviewer
          handleJobProfilePage={this.handleJobProfilePage}
          selectedJobProfileId={this.state.selectedJobProfileId}
          selectedMode={this.state.selectedMode}
          interviewerProfileValue={this.state.interviewerProfileValue}
          gotoSelectCandidate={this.gotoSelectCandidate}
          //interviewerProfileValue={this.state.interviewerProfileValue}
          interviewerPagePageinate={this.state.interviewerPagePageinate}
          onRadioSelectInterviewer={this.onRadioSelectInterviewer}
          onRadioUnselectInterviewer={this.onRadioUnselectInterviewer}
          interviewerPageNumber={this.interviewerPageNumber}
          gotoScheduleInterview={this.gotoScheduleInterview}
          onRadioSelect={this.onRadioSelect}
          gotoSelectInterviewer={this.gotoSelectInterviewer}
          text={this.state.text}
          changeText={this.changeText}
          availability={this.state.availability}
          selectedText={this.state.text}
          setAvailability={this.setAvailability}
          //jobId={this.state.selectedJobProfile.id}
          //selecttypeofInterviewValue={this.state.selecttypeofInterviewValue}
          index={this.state.index}
          candidateId={this.state.candidatePageValue.id}
        />
        {/* )} */}
        {this.state.activePage === "interviewDatePage" && <SelectDateAndTime />}
        {this.state.activePage === "paymentPreview" && (
          <PaymentPreview
            gotoSelectInterviewer={this.gotoSelectInterviewer}
            handleJobProfilePage={this.handleJobProfilePage}
            invoiceData={this.state.invoiceData}
            selectedJobProfileId={this.state.selectedJobProfileId}
            selectedMode={this.state.selectedMode}
          />
        )}
        {this.state.modeOfInterview && (
          <ModeOfInterview
            show={true}
            handleJobProfilePage={this.handleJobProfilePage}
            showModeModal={this.showModeModal}
          />
        )}
      </div>
    );
  }
}

export default CreateNewInterview;
